import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ModalBody } from "./Modal";
import { closeModal, openModal } from "../../redux/ModalSlice";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import noticeManager from "../../apis/notice";
import { MODAL_PAYLOAD } from "../../constants";
import paymentManager from "../../apis/paymentManager";
import { TableContentsArea, TableContentsData } from "../../routes/NoticeDetail";

const NoticeDetailModal = () => {
    const dispatch = useDispatch();
    const [contents, setContents] = useState(null);
    const { modalProps } = useSelector(
        (state) => state.modal
    );

    const { data: list } = useQuery({
        queryKey: ["readNoticeDetail"],
        queryFn: async () => {
            const res = await noticeManager.getNoticeDetail(7);
            return res.data;
        },
        enabled: !location.state, // location.state 없을 때만 호출
    });

    const { data: paymentInfo } = useQuery({
        queryKey: ["paymentInfo"],
        queryFn: async() => {
            const res = await paymentManager.getPayment();
            return res.data;
        },
    });

    useEffect(() => {
        if (list?.notice) {
            const notice = list.notice;
            setContents(notice.contents);
        }
    }, [list]);

    const onClickBtn = () => {
        const props = JSON.parse(JSON.stringify(MODAL_PAYLOAD.SCRIPT_DELETE));
        props.modalProps.script_src = paymentInfo?.script_src;
        dispatch(openModal({ ...props }));
    }

    return (
        <ModalBody $maxHeight={modalProps.maxHeight} $scroll={modalProps.scroll}>
            <ModalContainer>
                <TableContentsArea>
                    <TableContentsData colSpan={5}>
                        {contents}
                    </TableContentsData>
                </TableContentsArea>
            </ModalContainer>
            <ButtonWrap>
                <Button type="button" className="iv_btn" onClick={onClickBtn}>
                    확인
                </Button>
            </ButtonWrap>
        </ModalBody>
    );
};

const ModalContainer = styled.div`
    background-color: #F9F9FA;
    padding: 20px 20px 5px 20px;
    border-radius: 5px;
    overflow: auto;
    height: 600px;
`;

const ButtonWrap = styled.div`
    display: flex;
    width: 100%;
    justify-content: end;
    margin-top: 12px;
`;

const Button = styled.button`
    padding: 10px 24px;
    border-radius: 3px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: #FFFFFF;
    background: #7386E8;
`;

export default NoticeDetailModal;
